import { useState, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap-v5';
import Swal from 'sweetalert2';
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
import EmpresasService from '../../services/EmpresasService';

// DEVN3-618: configurações da EMPRESA (valem para todas as esteiras dela), abertas pelo botão
// "Opções" de /andamento-contas.
function ModalOpcoesEmpresa({ empresaID, show, toggleModal }: { empresaID: number, show: boolean, toggleModal: () => void }) {
    const { t } = useTranslation();
    const [conciliaPosicao, setConciliaPosicao] = useState(true);
    const [carregando, setCarregando] = useState(false);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (!show || !empresaID) return;
        setCarregando(true);
        EmpresasService.obterConciliaPosicaoFinanceira(empresaID)
            .then(setConciliaPosicao)
            .catch(() => Swal.fire({ text: t('Não foi possível carregar as opções da empresa.'), icon: 'error', timer: 3000, showConfirmButton: false }))
            .finally(() => setCarregando(false));
    }, [show, empresaID, t]);

    const alternarPosicao = useCallback(async (valor: boolean) => {
        if (!empresaID) return;
        setSalvando(true);
        try {
            await EmpresasService.salvarConciliaPosicaoFinanceira(empresaID, valor);
            setConciliaPosicao(valor);
            Swal.fire({ text: t('Opções da empresa atualizadas.'), icon: 'success', timer: 2000, showConfirmButton: false });
        } catch {
            Swal.fire({ text: t('Não foi possível salvar as opções da empresa.'), icon: 'error', timer: 3000, showConfirmButton: false });
        } finally {
            setSalvando(false);
        }
    }, [empresaID, t]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal">{t('Opções da empresa')}</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    <p className="text-muted" style={{ fontSize: 13 }}>
                        {t('Estas configurações valem para a empresa inteira, em todas as esteiras.')}
                    </p>

                    {carregando ? (
                        <div className="d-flex justify-content-center py-4">
                            <span className="spinner-border spinner-border-sm text-primary me-2 mt-1" />
                            <span>{t('Carregando...')}</span>
                        </div>
                    ) : (
                        <div style={{ border: '1px solid #eee', borderRadius: 5, padding: 12, backgroundColor: '#fff' }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="me-4">
                                    <div className="fw-bold" style={{ fontSize: 14 }}>{t('Concilia posição financeira')}</div>
                                    <div className="text-muted" style={{ fontSize: 12 }}>
                                        {t('Quando desligado, a capa das contas não exibe posição financeira (coluna, saldo × posição e alertas). Os dados importados são preservados.')}
                                    </div>
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={conciliaPosicao}
                                        disabled={salvando}
                                        onChange={(e) => alternarPosicao(e.target.checked)}
                                    />
                                    <label className="form-check-label" style={{ fontSize: 12 }}>
                                        {salvando ? t('Salvando...') : (conciliaPosicao ? t('Sim') : t('Não'))}
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default ModalOpcoesEmpresa;
